const apiUrl = process.env.REACT_APP_API_URL;

export default class OrderService {
  static get() {
    return fetch(`${apiUrl}/api/order/`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static getSales() {
    return fetch(`${apiUrl}/api/order/sales`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static confirmOrder(order_id: number) {
    return fetch(`${apiUrl}/api/order/sales/confirm`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: order_id }),
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static marketCancelOrder(order_id: number) {
    return fetch(`${apiUrl}/api/order/sales/cancel`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: order_id }),
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static cancelOrder(order_id: number) {
    return fetch(`${apiUrl}/api/order/cancel`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: order_id }),
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static add() {
    return fetch(`${apiUrl}/api/order/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      // body:JSON.stringify({product_id: productId,  quantity:quantity})
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static handleError(error: Error): void {
    console.error(error);
  }
}
